var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExpandIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 13.5,
    fill: "#EAFFFC",
    stroke: "#00B59A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0132 18.1052C13.9077 18.1052 13.811 18.0876 13.7231 18.0524C13.6352 18.0173 13.5473 17.9557 13.4593 17.8678L8.23736 12.6458C8.07912 12.4876 8 12.303 8 12.092C8 11.881 8.07912 11.6964 8.23736 11.5381C8.3956 11.3799 8.58462 11.3008 8.8044 11.3008C9.02418 11.3008 9.21319 11.3799 9.37143 11.5381L14.0132 16.1799L18.6549 11.5381C18.8132 11.3799 18.9978 11.3008 19.2088 11.3008C19.4198 11.3008 19.6044 11.3799 19.7626 11.5381C19.9209 11.6964 20 11.8854 20 12.1052C20 12.325 19.9209 12.514 19.7626 12.6722L14.567 17.8678C14.4791 17.9557 14.3912 18.0173 14.3033 18.0524C14.2154 18.0876 14.1187 18.1052 14.0132 18.1052Z",
    fill: "#00B59A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandIcon);
export default __webpack_public_path__ + "static/media/expand-icon.ab3101ada6ce1a6d3c017fae2947a4d2.svg";
export { ForwardRef as ReactComponent };